
import {
  hasError,
  hideSufix,
  placeholder,
  hasLocalizedLabels,
  options,
  selectClasses,
  textClasses,
  isDisabled,
  iconClasses,
  initialSelected,
} from './props'
import Icon from '~/components/atoms/icon/index.vue'

export default {
  components: {
    Icon,
  },
  props: {
    hasError,
    hideSufix,
    placeholder,
    hasLocalizedLabels,
    options,
    selectClasses,
    textClasses,
    isDisabled,
    iconClasses,
    initialSelected,
  },
  data() {
    return {
      selected: this.initialSelected,
    }
  },
  methods: {
    onChange(event) {
      const { value } = event.target

      const selectedOption = this.options.find(
        option => option.value.toString() === value
      )

      this.$emit('select', selectedOption, { fromMobile: true })
    },
    localizeLabel(label) {
      return this.hasLocalizedLabels ? this.$t(label) : label
    },
  },
}
